import { Progress } from 'app/javascript/components/ui/progress';
import { cn } from 'app/javascript/lib/utils';

interface UsageMeterProps {
  label: string;
  used: number;
  limit: number | null;
}

// Consumption against a plan limit. A bar answers "are they at the ceiling?"
// at a glance, which a pair of numbers does not. An unlimited plan gets no bar
// — there is no ceiling to be near.
//
// The track stays neutral in every state: a coloured track on an empty meter
// reads as a full one.
export default function UsageMeter({ label, used, limit }: UsageMeterProps) {
  const percent = limit ? Math.min(100, Math.round((used / limit) * 100)) : 0;
  const exhausted = limit !== null && used >= limit;

  return (
    <div className="space-y-1.5 py-1.5">
      <div className="flex items-baseline justify-between gap-4">
        <span className="text-xs text-muted-foreground">{label}</span>
        <span className="text-sm font-medium tabular-nums">
          {used.toLocaleString('pt-BR')}
          <span className="text-muted-foreground">
            {limit === null ? ' · sem limite' : ` / ${limit.toLocaleString('pt-BR')}`}
          </span>
        </span>
      </div>
      {limit !== null && (
        <Progress
          value={percent}
          aria-label={`${label}: ${percent}% do limite`}
          className={cn(
            'bg-secondary',
            exhausted && '[&>[data-slot=progress-indicator]]:bg-destructive'
          )}
        />
      )}
    </div>
  );
}
